import { CarrierServiceRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class CarrierServiceService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new CarrierServiceRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default CarrierServiceService;



// WEBPACK FOOTER //
// ./src/common/data/services/CarrierServiceService.js